export const DEFAULT_SORT = [
  {
    ascending: true,
    key: 'name'
  }
];